import ReactDOM from 'react-dom';

const FIELD_VIEW_ROOT_KEY = '__fieldViewReactRoot__';

type ReactRoot = {
  render: (component: unknown) => void;
};

type RootElement = Element & {
  [FIELD_VIEW_ROOT_KEY]?: ReactRoot;
};

/**
 * IMPORTANT: This method is a temporal utility to help in the migration from
 * React v16 to v18. It should be removed after the migration is completed.
 *
 * Render a component using the correct react-dom APIs dependending
 * on the ReactDOM version available in the context of execution.
 *
 * @param {Object} component React node to be rendered.
 * @param {Object} DOMEl DOM Element
 * @return {Object} ReactDOM rendered component
 */
export const renderUsingContextVersion = (component, DOMEl: RootElement | null) => {
  if (!DOMEl) return;

  const rootContainer = DOMEl;

  const {createRoot} = (ReactDOM as { createRoot?: (el: Element) => ReactRoot });
  const isModernReactDom = typeof createRoot === 'function';

  if (isModernReactDom) {
    if (!rootContainer[FIELD_VIEW_ROOT_KEY]) {
      rootContainer[FIELD_VIEW_ROOT_KEY] = createRoot(rootContainer);
    }

    rootContainer[FIELD_VIEW_ROOT_KEY]?.render(component);
    return;
  }

  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(component, DOMEl);
};
